import React, {useState} from "react"
import "../App.css"
import axios from "axios"
import {SERVER_URI} from "../utility/config"
import LoginRequest from "./LoginRequest"

function OrderPriorityTimeCreatedMessage(props) {
	window.setTimeout(function () {
		// Move to a new location
		props.handleClose()
	}, 1700)
	return (<div>
			<h2 className="message_title">Aika asetettu</h2>
		</div>)
}

function AddOrderPriorityTime(props) {
	const [show, setShow] = useState(false)
	const [orderPriorityTime, setOrderPriorityTime] = useState("")
	let storage = window.localStorage
	let userToken = storage.getItem("admin_token")

	//Look at this closer

	const onChange = (e) => {
		setOrderPriorityTime(e.target.value)
	}

	// Submit
	const doSubmit = async (e) => {
		e.preventDefault()
		const dataToServer = {
			orderPriorityTime: Number(orderPriorityTime),
		}
		try {
			await axios.put(`${SERVER_URI}/set_order_priority_time/`, dataToServer,{
				headers: {Authorization: `Token ${userToken}`}
			})
			props.dispatch({
				type: "UPDATE_ORDER_PRIORITY_TIME", data: {newOrderPriorityTime: orderPriorityTime},
			})
			setShow(!show)
		} catch (e) {
			console.log("Error in setting an order priority time.", e)
		}
	}
	return (<div className="popUp_card">
			<div className="popup-box">
				<div className="box">
          <span className="close-icon" onClick={props.handleClose}>
            x
          </span>
					{!show && (<div>
							<h2 className="popUp_title">Aseta aika </h2>
							<form className="timeLimit_form" onSubmit={(e) => doSubmit(e)}>
								<label className="label_add" htmlFor="timeLimit">
									Aika sekunteina:
								</label>
								<input
									type="number"
									id="priorityTime"
									name="priorityTime"
									onChange={onChange}
									placeholder="Aika"
									min="0"
									max="5000000000"
									required
								></input>{" "}
								sekuntia<span className="validity"></span>{" "}
								<br className="desktop-break"/>
								<input
									type="submit"
									id="gradient_Button"
									value="Aseta aika"
								/>
							</form>
						</div>)}
					{show && (<OrderPriorityTimeCreatedMessage handleClose={props.handleClose}/>)}
				</div>
			</div>
		</div>)
}

function OrderPriorityTime(props) {
	props.stopListRefresh()
	const [isOpen, setIsOpen] = useState(false)
	//const [isloggedIn, setIsloggedIn] = useState(true);
	//let storage = window.localStorage;
	//let userToken = storage.getItem("admin_token")

	/* useEffect(() => {
				const fetchLogin = async () => {
						if (userToken === null) {
								console.log("kirjaudu sisään")
								setIsloggedIn(false)
						}
				}
				fetchLogin();
				// DON'T DELETE THE COMMENT BELOW!!
				// eslint-disable-next-line react-hooks/exhaustive-deps
		}, []) */

	const togglePopUp = async () => {
		setIsOpen(!isOpen)
	}
	console.log("orderPriorityTime", props.orderPriorityTime)
	return (<div className="configurations">
			{isOpen && (<AddOrderPriorityTime
					dispatch={props.dispatch}
					handleClose={togglePopUp}
				/>)}
			<h3>Tilauksen priorisointiaika</h3>
			<div className="rides">
				{props.orderPriorityTime === undefined ? (<LoginRequest/>) : (<div className="customer_list">
						{props.orderPriorityTime} sekuntia
						<br/>
					</div>)}
			</div>
			<button id="gradient_Button" onClick={togglePopUp}>
				Aseta aika
			</button>
		</div>)
}

export default OrderPriorityTime
